import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-keep-routine',
    templateUrl: './keep-routine.component.html',
    styleUrls: ['./keep-routine.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KeepRoutineComponent {

}
